import { useEffect, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { Loader } from "@progress/kendo-react-indicators";
import { emptyGoal } from "../constants";
import { toDateInputValue } from "../utils/formatters";

const toDraft = (goal) => ({
  ...emptyGoal,
  ...(goal || {}),
  targetDate: toDateInputValue(goal?.targetDate || emptyGoal.targetDate)
});

export default function GoalDialog({ goal, isLoading, onClose, onSave, onValidationError, t = {} }) {
  const [draft, setDraft] = useState(toDraft(goal));

  useEffect(() => {
    setDraft(toDraft(goal));
  }, [goal]);

  const updateDraft = (changes) => setDraft((current) => ({ ...current, ...changes }));

  const submit = () => {
    if (!draft.title.trim() || !draft.targetAmount || Number(draft.targetAmount) <= 0) {
      onValidationError(t.addTitleAndTarget || "Add a title and a positive target amount.");
      return;
    }

    onSave(draft);
  };

  return (
    <Dialog title={goal ? t.editGoal || "Edit goal" : t.newGoal || "New goal"} onClose={onClose} width={500}>
      <div className="dialog-form">
        <div className="field full">
          <label>{t.goalTitle || "Goal title"}</label>
          <Input value={draft.title} placeholder={t.goalPlaceholder || "Vacation, new laptop, emergency fund"} onChange={(event) => updateDraft({ title: event.value })} />
        </div>
        <div className="field">
          <label>{t.targetAmount || "Target amount"}</label>
          <NumericTextBox value={draft.targetAmount} min={0} format="n2" onChange={(event) => updateDraft({ targetAmount: event.value })} />
        </div>
        <div className="field">
          <label>{t.currentProgress || "Current progress"}</label>
          <NumericTextBox value={draft.currentAmount} min={0} format="n2" onChange={(event) => updateDraft({ currentAmount: event.value })} />
        </div>
        <div className="field full">
          <label>{t.targetDate || "Target date"}</label>
          <DatePicker value={draft.targetDate} min={new Date()} onChange={(event) => updateDraft({ targetDate: event.value })} />
        </div>
        <div className="field full">
          <label>{t.description || "Description"}</label>
          <Input value={draft.description} placeholder={t.whyItMatters || "Why this target matters"} onChange={(event) => updateDraft({ description: event.value })} />
        </div>
      </div>
      <DialogActionsBar>
        {isLoading && <Loader size="small" />}
        <Button onClick={onClose} disabled={isLoading}>
          {t.cancel || "Cancel"}
        </Button>
        <Button themeColor="primary" icon="save" onClick={submit} disabled={isLoading}>
          {t.save || "Save"}
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}
